/**
 * @generated SignedSource<<482f7d31f52d97ab2f318d5074e06f74>>
 * @relayHash 143c98ff018aa1ff4230e9a1e86632ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a

import type { ConcreteRequest } from 'relay-runtime';
export type EditorFlagsContentAncestorsQuery$variables = {
  contentId: string;
};
export type EditorFlagsContentAncestorsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null;
      } | null> | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type EditorFlagsContentAncestorsQuery = {
  response: EditorFlagsContentAncestorsQuery$data;
  variables: EditorFlagsContentAncestorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorFlagsContentAncestorsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorFlagsContentAncestorsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "143c98ff018aa1ff4230e9a1e86632ca",
    "id": "c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a",
    "metadata": {},
    "name": "EditorFlagsContentAncestorsQuery",
    "operationKind": "query",
    "text": "query EditorFlagsContentAncestorsQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,ancestors{id}}}}"
  }
};
})();

(node as any).hash = "dae699d39d7456c23f9c77a8e35347ba";

export default node;
